import { Stack, Switch, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import StyleGroup from "../../../../viewer/chart/StyleGroup.tsx";
import HorizontalAlignmentItem from "./HorizontalAlignmentItem.tsx";
import Title from "./Title.tsx";
import VerticalAlignmentItem from "./VerticalAlignmentItem.tsx";

const LegendStyles = ({ readonlyMode }: { readonlyMode: boolean }) => {
  const settings = useSelector(selectChartSettingsState);
  const dispatch = useAppDispatch();

  return (
    <StyleGroup caption="Legend">
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        <Stack direction="row" sx={{ alignItems: "center" }}>
          <Typography color="textSecondary">Show Legend</Typography>
          <HorizontalFill />
          <Switch
            checked={settings.legend?.visible !== false}
            disabled={readonlyMode}
            slotProps={{ input: { "aria-label": "Show Legend" } }}
            onChange={(_, visible) => dispatch(fieldsStateActions.updateLegendSettings({ visible }))}
          />
        </Stack>
        <HorizontalAlignmentItem readonlyMode={readonlyMode} />
        <VerticalAlignmentItem readonlyMode={readonlyMode} />
        <Title readonlyMode={readonlyMode} />
      </Stack>
    </StyleGroup>
  );
};

export default LegendStyles;
